module.exports = __webpack_public_path__ + "static/img/tousu.88d38ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/tousu.png
// module id = t+XB
// module chunks = 0